import { Component, OnInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-alert-chart',
  templateUrl: './alert-chart.component.html',
  styleUrls: ['./alert-chart.component.scss']
})
export class AlertChartComponent implements OnInit {
  @Input() labelArray: any;
  @Input() valuesArray: any;

  constructor() { }

  ngOnInit() {
  }
  ngAfterViewInit() {
      this.processChartData();
  }

  processChartData(){
          var canvas = <HTMLCanvasElement>document.getElementById("alertChart");
          let backgroundColorArray = ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(153, 102, 255, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(255, 99, 132, 0.2)'];
          let borderColorArray = ['rgba(255,99,132,1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255,99,132,1)'];
          var mychart = new Chart(canvas, {
              type: 'horizontalBar',
              data: {
                  labels: this.labelArray,
                  datasets: [{
                      data: this.valuesArray,
                      backgroundColor: backgroundColorArray,
                      borderColor: borderColorArray,
                      borderWidth: 1,
                      fill: false,
                  }]
              },
              options: {
                  scales: {
                      yAxes: [{
                          ticks: {
                              beginAtZero: true
                          }
                      }]
                  },
                  legend: {
                      display: false
                  },
                  elements: {
                      point: {
                          radius: 0
                      }
                  }
              }
          });

  }

}